import React from 'react';
import { Box, BoxProps } from '@mui/material';

import { Chip } from '@occc-app/design-system';

import { Tooltip } from '../Tooltip';

export type ChipType = {
  id: string;
  name: string;
};

type InnerChipProps = {
  onClick?: (id: string) => void;
  onDelete?: (id: string) => void;
  item: ChipType;
};

const InnerChip = ({ onClick, item, onDelete }: InnerChipProps) => {
  const onClickMemo = React.useCallback(() => {
    onClick?.(item.id);
  }, [onClick, item]);
  const onDeleteMemo = React.useCallback(() => {
    onDelete?.(item.id);
  }, [onDelete, item]);

  return (
    <Tooltip title={item.name} key={item.id}>
      <Chip
        variant='outlined'
        label={item.name}
        onClick={onClick ? onClickMemo : undefined}
        onDelete={onDelete ? onDeleteMemo : undefined}
      />
    </Tooltip>
  );
};

type ChipBoxProps = {
  items: ChipType[];
  onClick?: (id: string) => void;
  onDelete?: (id: string) => void;
} & Omit<BoxProps, 'onClick'>;

export const ChipBox = ({ items, onClick, onDelete, ...restProps }: ChipBoxProps) => {
  return (
    <Box
      sx={{
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        mt: 3,
        mb: 3,
        display: 'flex',
        flexWrap: 'wrap',
        gap: 1,
      }}
      {...restProps}
    >
      {items.map((item) => (
        <InnerChip key={item.id} onClick={onClick} onDelete={onDelete} item={item} />
      ))}
    </Box>
  );
};
